import * as React from 'react';
import { GetServerSideProps, NextPage } from 'next';

import { ContentfulPageProps, ContentfulPage, contentfulGetServerSideProps } from '../templates/ContentfulPageTemplate';

const HomePage: NextPage<ContentfulPageProps> = (props) => {
  return <ContentfulPage {...props} />;
};

export const getServerSideProps: GetServerSideProps<ContentfulPageProps> = async (ctx) => {
  return await contentfulGetServerSideProps(ctx);
};

export default HomePage;
